import {Component, Input, OnInit} from '@angular/core';
import { CustomerProcedureInterfaceState } from '../../../lines/store/state/customer-procedure.state';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { CustomerProcedureInterface } from '../../../lines/models/customer-procedure.interface';
import { SelectedProcedureInterfaceState } from '../../../shared/store/state/selected-procedure.state';
import { GetCustomerProcedures } from '../../../lines/store/actions/customer-procedures.actions';
import { UpdateSelectedProcedure } from '../../../shared/store/actions/selected-procedure.actions';
import { AlertMessageInterface } from '../../../shared/models/alert-message.interface';
import { GetAlertMessage } from '../../../shared/store/actions/alert-message.actions';
import { PaymentsInterfaceState } from '../../store/state/payments.state';
import { PaymentsPaginatorInterface } from '../../models/payments.paginator.interface';
import { environment } from '../../../../../environments/environment';
import { Location } from '@angular/common';

@Component({
  selector: 'app-payments-management',
  templateUrl: './payments-management.component.html',
  styleUrls: ['./payments-management.component.css'],
  standalone: false
})
export class PaymentsManagementComponent implements OnInit {

  @Input()
  procedureInParam: string;

  payments: PaymentsPaginatorInterface;
  activeProceduresList: Array<CustomerProcedureInterface> = [];
  inProgressProceduresList: Array<CustomerProcedureInterface> = [];
  selectedProcedure: string = null;
  step: number;
  message: object;
  constHelper = ConstsHelper;

  constructor(
      private store: Store<any>,
      private location: Location
  ) {}

  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_CUSTOMER_PROCEDURES)).subscribe((response: CustomerProcedureInterfaceState) => {
      if (null !== response.customerProcedures) {
        this.activeProceduresList = [];
        this.inProgressProceduresList = [];
        for (const procedure of response.customerProcedures) {
          if (procedure.status === 'finished' && procedure.visibility) {
            this.activeProceduresList.push(procedure);
            if (this.procedureInParam === 'crediter-compte' && procedure.code === ConstsHelper.PROCEDURE_CREDIT_MY_ACCOUNT) {
              this.getProcedure(procedure);
            }
          } else if (procedure.visibility) {
            this.inProgressProceduresList.push(procedure);
          }
        }
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_SELECTED_PROCEDURE)).subscribe((response: SelectedProcedureInterfaceState) => {
      if (response.code != null) {
        this.selectedProcedure = response.code;
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_PAYMENTS)).subscribe((response: PaymentsInterfaceState) => {
      if (response.payments) {
        this.payments = response.payments;
      }
    });

    this.store.dispatch(new GetCustomerProcedures('payment', null));
  }

  getProcedure(procedure: CustomerProcedureInterface) {
    this.step = procedure.nextStep;
    if (procedure.lastMessage) {
      this.message = JSON.parse(procedure.lastMessage);
    }
    if (this.constHelper.PROCEDURE_NOT_RECEIVED_PAYMENT === procedure.code) {
      window.open(environment.data.vitrineUrl + '/ecv1/#!/assistance', '_blank');
    } else {
      if (procedure.code === ConstsHelper.PROCEDURE_CREDIT_MY_ACCOUNT && !this.location.path().includes('crediter-compte')) {
       this.location.replaceState(this.location.path() + '/crediter-compte');
      }

      this.store.dispatch(new UpdateSelectedProcedure(procedure.code));
    }
  }

  displayMessage(procedure: CustomerProcedureInterface) {
    let alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION_BY_SUPPORT, code: 300 } as AlertMessageInterface;
    if (procedure.status === ConstsHelper.PROCEDURE_STATUS_IN_PROGRESS) {
      alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION, code: 300 } as AlertMessageInterface;
    }
    this.store.dispatch(new GetAlertMessage(alertMessage));
  }
}
